import React from 'react';
import {Skeleton} from "primereact/skeleton";

const TableSkeleton = () => {
    return (
        <>
            <div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
                <div className="mb-3"><Skeleton className="w-full" height="3rem"></Skeleton></div>
            </div>
        </>
    );
};

export default TableSkeleton;